import { spacing } from '@cc-shopping/ui/theme';
import { buildUrl } from '@cc-shopping/utils/urlBuilder';
import Link from '@mui/material/Link';
import Image from 'next/image';
import type { ParamMap } from 'urlcat';
export const TransUnionLink = ({
  forceMobile,
  hideOddsButtonArrow = true
}: {
  forceMobile?: boolean;
  hideOddsButtonArrow?: boolean;
}) => <Link href={getTransunionUrl()} aria-label="Get my Credit Score" marginBottom={3} sx={theme => ({
  ...(!hideOddsButtonArrow && {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end'
  }),
  ...(forceMobile ? {
    marginLeft: spacing(2)
  } : {
    [theme.breakpoints.up('md')]: {
      position: 'relative'
    },
    [theme.breakpoints.down('md')]: {
      marginLeft: spacing(2)
    }
  })
})}>
    <Image width={100} height={26} src="https://nerdwallet.com/cdn/cc/transunion-logo-darker-grey.svg" alt="TransUnion logo" />
    {!hideOddsButtonArrow && <span aria-hidden="true" className="mask-icon mask-icon-arrow-forward" style={{
    width: '20px',
    height: '20px',
    backgroundColor: '#8B8C8F'
  }} />}
  </Link>;
const getTransunionUrl = (overrideParams?: ParamMap) => {
  return buildUrl('/home/dashboard/credit-score', {
    ...overrideParams
  });
};